export default __webpack_public_path__ + "3168bbbc25226495bffe8497acdfdd2b.png";